var $924ec5973b9d52a8$exports = {};
$924ec5973b9d52a8$exports = {
  "collapse": "\xD6sszecsuk\xE1s",
  "expand": "Kibont\xE1s"
};
export { $924ec5973b9d52a8$exports as default };